import { useEffect, useState } from "react";
import { tokens } from "@/art/tokens";

/**
 * 고정 1920×1080 설계를 브라우저 창에 맞춰 letterbox 스케일.
 * 창이 더 좁으면 가로 기준, 더 넓으면 세로 기준으로 축소.
 */
export function useViewportScale(): { scale: number; width: number; height: number } {
    const [dim, setDim] = useState(() => compute());

    useEffect(() => {
        const handle = () => setDim(compute());
        window.addEventListener("resize", handle);
        window.addEventListener("orientationchange", handle);
        return () => {
            window.removeEventListener("resize", handle);
            window.removeEventListener("orientationchange", handle);
        };
    }, []);

    return dim;
}

function compute() {
    const { designWidth, designHeight } = tokens.viewport;
    const w = window.innerWidth;
    const h = window.innerHeight;
    const designAspect = designWidth / designHeight;
    const currentAspect = w / h;
    const scale = currentAspect > designAspect
        ? h / designHeight   // 세로 기준
        : w / designWidth;   // 가로 기준
    return { scale, width: w, height: h };
}
